import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import {TokenCommonService} from '../token-common.service';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class CategoriaDocumentosService extends TokenCommonService {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  gatAll(params?: any) {
    return this.tokenGet(`${ environment.API_URL }categoriasDocumento`, params);
  }

  create(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }categoriasDocumento`, data);
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }categoriasDocumento/${id}`, data);
  }

  delete(id: number) {
    return this.tokenDelete(`${ environment.API_URL }categoriasDocumento/${id}`);
  }

  getDocuments(id: number) {
    return this.tokenGet(`${ environment.API_URL }categoriasDocumento/${id}/documento/activos`);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/categoria-documentos/categoria-documentos.service.ts